import React, {useEffect, useState} from 'react';
import axios from 'axios';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import Moment from 'react-moment';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import ListItemText from '@material-ui/core/ListItemText';
import Alert from '@material-ui/lab/Alert';
import RegisterButton from "../RegisterButton/RegisterButton";

export interface IPlace {
  title: string,
  addressLine1: string,
  postalCode: string,
  locality: string,
  images: any,
  uuid: string,
}

export interface IEvent {
  uuid: string,
  starts: string,
  ends: string,
  title: string,
  description?: string,
  seats: number,
  seatsAvailable: number,
  image: any,
}

export interface IEventData {
  id: string,
  place?: IPlace,
  events?: IEvent[],
}


export interface IEventListProps {
  event: string,
  closingDate: string
}

export interface IEventListState {
  isLoading: boolean,
  eventData: IEventData,
}

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: '6px 16px',
  },
  secondaryTail: {
    backgroundColor: theme.palette.secondary.main,
  },
  root: {
    boxShadow: '2px -2px 4px rgb(0, 0, 0, 0.4)',
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  inline: {
    display: 'inline',
  },
  listDate: {
    color: theme.palette.primary.main,
    fontSize: '1.375rem',
  },
  listItemHeader: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    lineHeight: '1.3',
    marginBottom: '12px',
  },
  header: {
    '& .MuiCardHeader-title': {
      marginBottom: '10px',
    }
  },
  subheader: {
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
    },

    background: '#f1f1f1',
    marginBottom: '8px',
  },
  subheaderImage: {
    paddingRight: '25px',

  },
  subheaderImageImg: {
    display: 'block',
  },
  subheaderName: {
    marginTop: '8px',
    marginBottom: '3px',
  },

  subheaderText: {
    // paddingLeft: '5px',
  },
  rootList: {

  },
  content: {
    padding: '0',
  },
  eventImage: {
    float: 'left',
    paddingTop: '5px',
    paddingRight: '12px',
  },
  eventDescription: {
    color: 'rgba(0, 0, 0, 0.64)',
    fontSize: '1rem',
    lineHeight: '1.43',
  },
  seatsNotice: {
    color: '#f68920',
    clear: 'both',
    paddingTop: '1px',
  }
}));


const EventList = (props: IEventListProps) => {
  const [eventData, setEventData] = useState<IEventData>({id: ""});
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const classes = useStyles();

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    var getUrl = window.location;
    var baseURL = getUrl .protocol + "//" + getUrl.host;
    if (baseURL == 'http://localhost:3000') {
      baseURL = 'https://buxliest.local.computer';
    }
    axios.get(baseURL + "/bux-api/bux-event/event-data/" + props.event + "?_format=json", {
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((result) => {
        setEventData(result.data);
      })
      .catch(error => {
        if (error.response) {
          console.log(error.responderEnd);
        }
      });
  }

  const handleSnackbarClose = (event: any) => {
    setSnackbarOpen(false);
  };

  const addAttendeeSuccess = () => {
    setSnackbarOpen(true);
    loadData();
  };

  const date = new Date();
  const closingDate = new Date(props.closingDate);
  const closed = date.getTime() > closingDate.getTime();

  console.log({date:date, closingDate:closingDate, closed:closed});


  return (
    <Box>
      {/*{eventData.place && (*/}
      {/*  <Box>*/}
      {/*    {eventData.place?.title}<br/>*/}
      {/*    {eventData.place?.addressLine1}<br/>*/}
      {/*    {eventData.place?.postalCode}*/}
      {/*    {eventData.place?.locality}*/}
      {/*  </Box>*/}
      {/*)}*/}

      {eventData.place && eventData.events && (
        <Box className={classes.root}>


                <Box className={classes.subheader}>
                  {eventData.place?.images?.length > 0 &&
                  <Box className={classes.subheaderImage}>
                    <img  className={classes.subheaderImageImg} src={eventData.place?.images[0].thumbnail.url}/>
                  </Box>
                  }
                  <Box className={classes.subheaderText}>
                    <h2 className={classes.subheaderName}>{eventData.place?.title}</h2>
                    <Typography>{eventData.place?.addressLine1},&nbsp;
                      {eventData.place?.postalCode}&nbsp;
                      {eventData.place?.locality}</Typography>
                    {eventData.events.length > 0 &&
                    <Moment format="DD.MM.YYYY" parse="YYYY-MM-DDTHH:mm:ss">
                      {eventData.events[0].starts}
                    </Moment>
                    }
                  </Box>
                </Box>

            <List className={classes.rootList} disablePadding>
              {eventData.events.map((item, index) => {
                return (
                  <>
                    <ListItem alignItems="flex-start" key={item.uuid}>
                      {/*<ListItemAvatar>*/}
                      {/*  <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg"/>*/}
                      {/*</ListItemAvatar>*/}
                      <ListItemText
                        disableTypography
                        primary={
                          <React.Fragment>
                            <Box className={classes.listDate}>
                              <Moment format="HH:mm U\hr" parse="YYYY-MM-DDTHH:mm:ss">
                                {item.starts}
                              </Moment>
                            </Box>
                            <Box className={classes.listItemHeader}>{item.title}</Box>
                          </React.Fragment>
                        }
                        secondary={
                          <React.Fragment>
                            {item?.image?.thumbnail &&
                            <Box className={classes.eventImage}>
                              <img src={item?.image.thumbnail.url}/>
                            </Box>
                            }
                            <Box className={classes.eventDescription}
                              // className={classes.root}
                              // variant="body1"
                              dangerouslySetInnerHTML={{
                                __html: item?.description?.toString() ?? ""
                              }}
                            ></Box>

                            {!closed &&item.seatsAvailable > 0 && (
                              <Box className={classes.seatsNotice}><p>Noch {item.seatsAvailable} freie Plätze</p></Box>
                            )}
                            {!closed &&item.seatsAvailable <= 0 && (
                              <Box className={classes.seatsNotice}><p>Momentan sind keine Plätze frei. Sie können sich aber auf die Warteliste setzen.</p></Box>
                            )}
                            {!closed && (
                              <RegisterButton place={eventData.place} event={item}
                                              successCallback={addAttendeeSuccess}></RegisterButton>
                            )}
                            {closed && (
                              <Box className={classes.seatsNotice}><p>Der Anmeldeschluss ist erreicht. Es besteht die
                                Möglichkeit, sich spontan vor Ort anzumelden - sofern für die Lesung noch Plätze frei sind.</p></Box>


                            )}
                            <Snackbar open={snackbarOpen} autoHideDuration={8000} onClose={handleSnackbarClose}>
                              <Alert onClose={handleSnackbarClose} severity="success">
                                Das hat funktioniert. Sie bekommen eine Bestätigung per E-Mail.
                              </Alert>
                            </Snackbar>
                          </React.Fragment>
                        }
                      />
                    </ListItem>
                    <Divider component="li"/>

                  </>
                );
              })
              }


            </List>

        </Box>
      )}

      {/*{eventData.events && (*/}
      {/*  <Timeline align="left">*/}
      {/*    {eventData.events.map((item, index) => {*/}
      {/*      return (*/}
      {/*        <TimelineItem key={item.uuid}>*/}
      {/*          <TimelineOppositeContent>*/}

      {/*          </TimelineOppositeContent>*/}
      {/*          <TimelineSeparator>*/}
      {/*            <TimelineDot color="primary" variant="outlined">*/}
      {/*              <LocalLibraryIcon />*/}
      {/*            </TimelineDot>*/}
      {/*            <TimelineConnector />*/}
      {/*          </TimelineSeparator>*/}
      {/*          <TimelineContent>*/}
      {/*            <Paper elevation={3} className={classes.paper}>*/}
      {/*              <Typography variant="body2" color="textSecondary">*/}
      {/*                <Moment format="HH:mm U\hr" parse="YYYY-MM-DDTHH:mm:ss">*/}
      {/*                  {item.starts}*/}
      {/*                </Moment>*/}
      {/*              </Typography>*/}
      {/*              <Typography variant="h6" component="h1">*/}
      {/*                Eat*/}
      {/*              </Typography>*/}
      {/*              <Typography>Because you need strength</Typography>*/}
      {/*              <Button variant="contained"*/}
      {/*                      color="primary">An Event teilnehmen</Button>*/}
      {/*            </Paper>*/}
      {/*          </TimelineContent>*/}
      {/*        </TimelineItem>*/}

      {/*      );*/}
      {/*    })*/}
      {/*    }*/}
      {/*  </Timeline>*/}
      {/*)}*/}

    </Box>
  );
}


export default EventList;

